import React, { useState } from 'react'
import { useTaskContext } from '../../../../context/TaskContext';
import { useSelector } from 'react-redux';
import TaskDetailsWarning from '../../TaskDetails/TaskDetailsWarning';

export default function RoomModal({ open, onClose, type, onSelectRoom }) {
    console.log('Room popup open:', open);

    const { OnUpdateTask } = useTaskContext();
    const { user, conversations } = useSelector(state => state.message);
    const { active_task } = useSelector(state => state.task);
    // const [searchQuery, setSearchQuery] = useState('');
    const [temp_room, setTemp_room] = useState(null);
    const [roomSelectWarning, setRoomSelectWarning] = useState(false);
    const [search, setSearch] = useState("");

    const filteredRooms = conversations?.filter(room => room.title.toLowerCase().includes(search.toLowerCase()) && active_task?.conversation_id !== room.conversation_id);

    const handleRoomSelect = (room) => {
        console.log(21, room);

        if (type === 'create') {
            console.log(25, room);
            onSelectRoom(room);
            onClose();
        } else {
            console.log(28, room);
            setTemp_room(room);
            setRoomSelectWarning(true);
        }
    };

    const handleConfirmRoomChange = (room) => {
        setRoomSelectWarning(false);
        OnUpdateTask({
            conversation_id: temp_room?.conversation_id,
            conversation_name: temp_room?.title,
            conversation_img: temp_room?.conv_img,
            participants: temp_room?.participants,
            assign_to: [],
            observers: [],
        })
        onClose();
    }

    if (!open) return null;

    return (
        <>
            <div className="fixed inset-0 z-50 flex items-end justify-center">
                {/* Backdrop */}
                <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />

                {/* Sheet */}
                <div className="relative w-full max-w-sm bg-white rounded-t-3xl shadow-2xl pb-safe"
                    style={{ animation: "slideUp 0.25s cubic-bezier(0.32,0.72,0,1)" }}>

                    <style>{`
          @keyframes slideUp {
            from { transform: translateY(100%); opacity: 0; }
            to   { transform: translateY(0);    opacity: 1; }
          }
          @keyframes chipIn {
            from { transform: scale(0.7); opacity: 0; }
            to   { transform: scale(1);   opacity: 1; }
          }
          .chip-enter { animation: chipIn 0.18s cubic-bezier(0.34,1.56,0.64,1) forwards; }
        `}</style>

                    {/* Drag handle */}
                    <div className="flex justify-center pt-3 pb-1">
                        <div className="w-10 h-1 bg-slate-200 rounded-full" />
                    </div>

                    {/* Header */}
                    <div className="flex items-center justify-between px-5 pt-3 pb-4">
                        <div>
                            <h2 className="text-base font-bold text-slate-800">Rooms</h2>
                            <p className="text-xs text-slate-400 mt-0.5">Select a room to organize this task</p>
                        </div>
                        <button onClick={onClose}
                            className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center hover:bg-slate-200 transition-colors">
                            <svg className="w-4 h-4 text-slate-500" fill="none" viewBox="0 0 24 24">
                                <path d="M6 18L18 6M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                        </button>
                    </div>

                    {/* Active keywords */}

                    <div className="px-5 pb-4">
                        <p className="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-2">Active</p>
                        <div className="flex flex-wrap gap-2">
                            <div className="chip-enter flex items-center gap-1.5 bg-violet-50 border border-violet-200 rounded-full pl-3 pr-2 py-1">
                                <span className="text-xs font-semibold text-violet-700">{active_task?.conversation_name !== user?.name ? active_task?.conversation_name : 'You'}</span>
                                {/* <button onClick={() => OnUpdateTask({ key_words: [...active_task?.key_words?.filter(f => f !== kw)], save_type: 'keyword' })}
                                    className="w-4 h-4 rounded-full bg-violet-200 hover:bg-violet-300 flex items-center justify-center transition-colors">
                                    <svg className="w-2.5 h-2.5 text-violet-600" fill="none" viewBox="0 0 24 24">
                                        <path d="M6 18L18 6M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </button> */}
                            </div>
                        </div>
                    </div>

                    {/* Divider */}
                    <div className="mx-5 border-t border-slate-100 mb-4" />

                    {/* Search input */}
                    <div className="px-5 mb-3">
                        <div className="relative">
                            <svg className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" fill="none" viewBox="0 0 24 24">
                                <path d="M21 21l-4.35-4.35M17 11A6 6 0 115 11a6 6 0 0112 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                            <input
                                autoFocus
                                value={search}
                                onChange={e => setSearch(e.target.value)}
                                placeholder="Search or room…"
                                className="w-full bg-slate-50 border border-slate-200 rounded-2xl pl-10 pr-9 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-violet-400 focus:bg-white transition-all placeholder-slate-300"
                            />
                            {search && (
                                <button onClick={() => setSearch("")}
                                    className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 rounded-full bg-slate-200 flex items-center justify-center hover:bg-slate-300 transition-colors">
                                    <svg className="w-3 h-3 text-slate-500" fill="none" viewBox="0 0 24 24">
                                        <path d="M6 18L18 6M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </button>
                            )}
                        </div>
                    </div>

                    {/* Suggestions list */}
                    <div className="px-5 overflow-y-auto" style={{ maxHeight: "200px" }}>
                        {filteredRooms?.length > 0 ? (
                            <div className="space-y-0.5">
                                {filteredRooms?.map(room => (
                                    <button key={room.conversation_id} onClick={() => { handleRoomSelect(room); setSearch('') }}
                                        className="w-full flex items-center justify-between px-3 py-2.5 rounded-xl hover:bg-violet-50 transition-colors group text-left">
                                        <span className="text-sm text-slate-700 group-hover:text-violet-700 font-medium transition-colors">
                                            {room.title}
                                        </span>
                                        <svg className="w-4 h-4 text-slate-300 group-hover:text-violet-500 transition-colors" fill="none" viewBox="0 0 24 24">
                                            <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                        </svg>
                                    </button>
                                ))}
                            </div>
                        ) : (
                            <div className="flex flex-col items-center py-6 text-center">
                                <div className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center mb-2">
                                    <svg className="w-5 h-5 text-slate-300" fill="none" viewBox="0 0 24 24">
                                        <path d="M7 7h10M7 12h10M7 17h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <p className="text-xs text-slate-400">No rooms found</p>
                                <p className="text-xs text-slate-300 mt-0.5">Try a different search term</p>
                            </div>
                        )}
                    </div>

                    {/* Bottom padding for safe area */}
                    <div className="h-6" />
                </div>
            </div>
            <TaskDetailsWarning type="roomChange" isOpen={roomSelectWarning} onClose={() => setRoomSelectWarning(false)} onConfirm={handleConfirmRoomChange} />
        </>
    );
}
